import CryptoJS from "crypto-js";

const FE_KEY = import.meta.env.VITE_FE_ENCRYPTION_KEY!;
const FE_IV = import.meta.env.VITE_FE_IV!;
console.log("FE_KEY:", FE_KEY);
console.log("FE_IV:", FE_IV);



export class EncryptionUtil {
  static encrypt(text: string) {
    const key = CryptoJS.enc.Hex.parse(FE_KEY);
    const iv = CryptoJS.enc.Hex.parse(FE_IV);


    const encrypted = CryptoJS.AES.encrypt(
      text,
      key,
      {
        iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    );

    return encrypted.toString();
  }

  static decrypt(cipher: string) {
    const key = CryptoJS.enc.Hex.parse(FE_KEY);
    const iv = CryptoJS.enc.Hex.parse(FE_IV);

    const decrypted = CryptoJS.AES.decrypt(
      cipher,
      key,
      {
        iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    );

    return decrypted.toString(CryptoJS.enc.Utf8);
  }
}